module.exports = __webpack_public_path__ + "static/media/Test5.21754400.bmp";